import tabs from "./en/tabs";
import pages from "./en/pages";
import appLauncher from "./en/appLauncher";
import apps from "./en/apps";
import auditLog from "./en/auditLog";
import roadmapPage from "./en/roadmapPage";
import ceoQueue from "./en/ceoQueue";
import common from "./en/common";
import speedDial from "./en/speedDial";
import smartBar from "./en/smartBar";
import auth from "./en/auth";
import settings from "./en/settings";
import sidebar from "./en/sidebar";
import tray from "./en/tray";
import shellPrefs from "./en/shellPrefs";
import userMenu from "./en/userMenu";
import downloads from "./en/downloads";
import brand from "./en/brand";
import contextMenu from "./en/contextMenu";
import elementLabels from "./en/elementLabels";
import elementDescriptions from "./en/elementDescriptions";
import guide from "./en/guide";
import folders from "./en/folders";
import fieldLibrary from "./en/fieldLibrary";
import canvas from "./en/canvas";
import storyMap from "./en/storyMap";
import health from "./en/health";
import dashboardHome from "./en/dashboardHome";
import hub from "./en/hub";
import boardroom from "./en/boardroom";
import documentsPage from "./en/documentsPage";
import exportNs from "./en/export";
import docControl from "./en/docControl";
import docTemplates from "./en/docTemplates";
import docFields from "./en/docFields";
import fieldConfig from "./en/fieldConfig";
import emailTemplates from "./en/emailTemplates";
import emailDesigner from "./en/emailDesigner";
import relativeTime from "./en/relativeTime";
import layers from "./en/layers";
import home from "./en/home";
import admin from "./en/admin";
import audit from "./en/audit";
import widgets from "./en/widgets";
import gallery from "./en/gallery";
import designSystem from "./en/designSystem";
import projectDetail from "./en/projectDetail";
import functionalMap from "./en/functionalMap";
import architecturePage from "./en/architecturePage";
import planPage from "./en/planPage";
import automations from "./en/automations";
import rss from "./en/rss";
import editor from "./en/editor";
import aiHub from "./en/aiHub";
import bottomBar from "./en/bottomBar";
import comms from "./en/comms";
import email from "./en/email";
import pwa from "./en/pwa";
import entities from "./en/entities";
import wiki from "./en/wiki";
import toolkit from "./en/toolkit";
import iconPicker from "./en/iconPicker";
import grid from "./en/grid";
import slides from "./en/slides";
import matching from "./en/matching";
import contractor from "./en/contractor";
import importEngine from "./en/importEngine";
import gmail from "./en/gmail";
import googleCalendar from "./en/googleCalendar";
import courses from "./en/courses";
import workspaceSwitcher from "./en/workspaceSwitcher";
import knowledge from "./en/knowledge";

export const en = { tabs, pages, appLauncher, apps, auditLog, roadmapPage, ceoQueue, common, speedDial, smartBar, auth, settings, sidebar, tray, shellPrefs, userMenu, downloads, brand, contextMenu, elementLabels, elementDescriptions, guide, folders, fieldLibrary, canvas, storyMap, health, dashboardHome, hub, boardroom, documentsPage, export: exportNs, docControl, docTemplates, docFields, fieldConfig, emailTemplates, emailDesigner, relativeTime, layers, home, admin, audit, widgets, gallery, designSystem, projectDetail, functionalMap, architecturePage, planPage, automations, rss, editor, aiHub, bottomBar, comms, email, pwa, entities, wiki, toolkit, iconPicker, grid, slides, matching, contractor, importEngine, gmail, googleCalendar, courses, workspaceSwitcher, knowledge } as const;
